export default "__VITE_ASSET__DaHHzOdN__"